import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styles from '../../../src/assets/styles/HomePage.module.scss';

import Header from '../Header';
import Footer from '../Footer';

import Menu from '../Menu';
import ModalEditMenu from '../ModalEditMenu';
import { useAuth } from '../../contexts/AuthContext';
import { apiFetch } from '../../services/apiService';

const Kavarna = () => {
    const { user } = useAuth();
    const [menuCategories, setMenuCategories] = useState([]);

    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const data = await apiFetch('/api/menu/getCompleteMenu');
                console.log( "/api/menu/getCompleteMenu" );
                console.log( data );
                setMenuCategories(data);
            } catch (error) {
                console.error('Chyba při načítání položek menu:', error);
            }
        };
        fetchMenuItems();
    }, []);
    return (
        <div>
            <Container fluid className={`g-0`}>
                <Header headerAbsolute={true} />
                <div className={`${styles.heroImage} ${styles.heroImageKavarna}`}>

                    <div className={styles.heroText}>
                        <h1>Kavárna</h1>
                        <p className='lead'>
                            Kavárna, kde dětský smích rezonuje s každým douškem
                        </p>


                    </div>
                </div>
            </Container>
            {user && (
                <ModalEditMenu menuCategories={menuCategories} setMenuCategories={setMenuCategories} />
            )}
            <Container className=''>
                <Menu menuCategories={menuCategories} />
            </Container>
            <Footer/>
        </div >
        
    );
};

export default Kavarna;
